import { render, staticRenderFns } from "./SendEmail.vue?vue&type=template&id=6f978782&scoped=true&"
import script from "./SendEmail.vue?vue&type=script&lang=js&"
export * from "./SendEmail.vue?vue&type=script&lang=js&"
import style0 from "./SendEmail.vue?vue&type=style&index=0&id=6f978782&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f978782",
  null
  
)

export default component.exports